export default {
  CAT_TEA: 0b10,
  CAT_TAPI: 0b100,
  CAT_CAP: 0b1000
}
